function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M140 75v55c0 5.54-4.46 10-10 10h-25.438a7.5 7.5 0 0 1 .438 2.5 7.5 7.5 0 0 1-7.5 7.5H130c11.08 0 20-8.92 20-20V75h-10zm-42.5 75a7.5 7.5 0 0 1-7.357-6.076V150H97.5zm-7.357-10v1.06a7.5 7.5 0 0 1 .296-1.06h-.296z",
  fill: "#2b7ca7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M80 0a70 80 0 0 0-70 80h10a60 70 0 0 1 60-70 60 70 0 0 1 60 70h10A70 80 0 0 0 80 0zM97.5 125A17.5 17.5 0 0 0 80 142.5 17.5 17.5 0 0 0 97.5 160a17.5 17.5 0 0 0 17.5-17.5A17.5 17.5 0 0 0 97.5 125zm0 10a7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 1-7.5 7.5 7.5 7.5 0 0 1-7.5-7.5 7.5 7.5 0 0 1 7.5-7.5z",
  fill: "#2b7ca7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 55C8.92 55 0 63.92 0 75v10c0 11.08 8.92 20 20 20h10V55zM140 55c11.08 0 20 8.92 20 20v10c0 11.08-8.92 20-20 20h-10V55z",
  fill: "#2b7ca7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M80 20c-15.76.035-30.583 8.984-40 24.148v81.682c7.425 11.916 18.352 20.247 30.783 23.053A27.5 27.5 0 0 1 70 142.5a27.5 27.5 0 0 1 .33-4.016l-.04-.004L69 138s2.4-11.19 6.063-14.813c5.726-5.665 13.197-9.648 21.25-9.874 8.874-.25 13.687 3.304 13.687 3.304v1.44a27.5 27.5 0 0 1 9.69 8.255A63.316 63.316 0 0 0 125.386 115H120V44.162C110.586 28.992 95.762 20.038 80 20z",
  fill: "#4e6476"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M80 30a40 50 0 0 0-30 17.023v75.985a40 50 0 0 0 20.328 15.484A27.5 27.5 0 0 1 97.5 115a27.5 27.5 0 0 1 12.5 3.037V46.992A40 50 0 0 0 80 30z",
  fill: "#fff"
});

function SvgSupportlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportlog);
export default __webpack_public_path__ + "static/media/supportlog.9dbada0759af175f56766ebfd8edc755.svg";
export { ForwardRef as ReactComponent };